window.submoduleBrunchNames = {
  [OPUtility.eSubmoduleNames.ESN_OP_WRAPPER_SERVICE]: 'master',
  [OPUtility.eSubmoduleNames.ESN_OP_PRELOADER]: 'master'
}
